import { render, staticRenderFns } from "./ShareDetails.vue?vue&type=template&id=1bfbba16&scoped=true"
import script from "./ShareDetails.vue?vue&type=script&lang=js"
export * from "./ShareDetails.vue?vue&type=script&lang=js"
import style0 from "./ShareDetails.vue?vue&type=style&index=0&id=1bfbba16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfbba16",
  null
  
)

export default component.exports